import {
    ApplicationConfig, CSP_NONCE,
    ErrorHandler,
    inject,
    provideAppInitializer,
    provideZoneChangeDetection
} from '@angular/core';
import {provideRouter, withInMemoryScrolling} from '@angular/router';

import {routes} from './app.routes';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {ApiUrlService} from "./core/services/apiservices/api-url.service";
import {requestInterceptor} from "./core/interceptors/request.interceptor";
import {provideI18Next} from "angular-i18next";
import {GlobalErrorHandler} from "./core/services/global-error-handler.service";
import {LanguageEventsService} from "./core/services/apiservices/language-events.service";
import {MatomoService} from "./core/services/matomo.service";
import {APP_BASE_HREF} from "@angular/common";

const nonce = document.body.dataset["cspNonce"];
const baseHref = document.body.dataset["baseHref"];

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({eventCoalescing: true}),
        provideRouter(
            routes,
            withInMemoryScrolling({ scrollPositionRestoration: "top", })
        ),
        provideHttpClient(
            withInterceptors([requestInterceptor])
        ),
        provideI18Next(),
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        ApiUrlService,
        provideAppInitializer(() => {
            inject(LanguageEventsService);
        }),
        provideAppInitializer(() => {
            inject(MatomoService).initializeTagManager();
        }),
        {provide: APP_BASE_HREF, useValue: baseHref && baseHref !== '__BASE_HREF__' ? baseHref : '/'},
        {provide: CSP_NONCE, useValue: nonce && nonce !== '___CSP_NONCE___' ? nonce : ''},
    ]
};